export default {"src":"/_next/static/media/icon-flash.component.17ac2caa.svg","height":11,"width":6,"blurWidth":0,"blurHeight":0};